/** @shared/ui — 포탈 제품 버전 (packages/config/src/version.ts 와 동일 값 유지) */
export const PORTAL_VERSION = '4.0' as const
export const PORTAL_VERSION_FOOTER = `IAMPAM ITops version ${PORTAL_VERSION}` as const
